import React from "react";
import { Section, ScrollContainer, ToolCard, ToolIcon, ToolTitle, ToolDesc } from "./desktopGuiToolsStyled";

const desktopTools = [
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771458307/pyqt6-1693678112_1_xjmhxq.svg",
    alt: "PyQt",
    title: "PyQt6",
    desc: "Python bindings for Qt for building GUI apps",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771458815/Untitled-1_1_yzbg6b.svg",
    alt: "PySide",
    title: "PySide6",
    desc: "Python bindings for Qt for building GUI apps",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771470378/qtdesigner_bmbewb.png",
    alt: "Qt Designer",
    title: "Qt Designer",
    desc: "Visual GUI design tool for creating Qt applications with drag-and-drop widgets"

  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771469732/vbdotnet_2_uxwngf.svg",
    alt: "VB.NET",
    title: "VB.NET",
    desc: "Object-oriented programming language for building Windows, desktop, web, and enterprise applications using the .NET framework",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771471142/java_swing_g0wjqg.png",
    alt: "Java Swing",
    title: "Java Swing",
    desc: "Java GUI toolkit for building desktop applications with a platform-independent windowing system",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771554287/25-255604_android-studio-logo-png-android-studio-icon-png-3129754859_glotck.png",
    alt: "Android Studio",
    title: "Android Studio",
    desc: "Official IDE for developing Android apps with built-in tools for coding, debugging, and testing",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1772066007/pywebview_jkmsar.png",
    alt: "PyWebView",
    title: "PyWebView",
    desc: "A lightweight Python library to create native desktop apps using HTML, CSS, and JavaScript with Python integration.",
  },
];

const DesktopGuiToolsSection = () => {
  return (
    <Section id="desktop-gui-tools">
      <ScrollContainer>
        {desktopTools.map((tool, idx) => (
          <ToolCard key={idx}>
            <ToolIcon src={tool.src} alt={tool.alt} loading="lazy"/>
            <ToolTitle>{tool.title}</ToolTitle>
            {/* <ToolDesc>{tool.desc}</ToolDesc> */}
          </ToolCard>
        ))}
      </ScrollContainer>
    </Section>
  );
};

export default DesktopGuiToolsSection;
